import { AiSummary as AiSummaryBase } from "@brivity/ai-components";
import AiProvider from "./AiProvider";

const AiSummary = ({ allowAddAI, leadPersonUuid, phoneStatus, variant }) => (
  <AiProvider>
    <AiSummaryBase
      allowAddAI={allowAddAI}
      leadPersonUuid={leadPersonUuid}
      phoneStatus={phoneStatus}
      variant={variant}
    />
  </AiProvider>
);

export default AiSummary;
